/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum GCMOptionType
{
    MUTE = "MUTE",
    TURBO = "TURBO",
    ABOUT = "ABOUT",
    HELP = "HELP",
    PAYTABLE = "PAYTABLE",
    GAME_PREFERENCE = "GAME_PREFERENCE"
}

export enum GCMOptionSrc
{
    COMMONUI = "COMMONUI",
    GAME = "GAME"
}

export enum ErrorCategory
{
    CONNECTION_ERROR,
    CRITICAL,
    INSUFFICIENT_FUNDS,
    LOGIN_ERROR,
    NON_RECOVERABLE_ERROR,
    REALITY_CHECK,
    RECOVERABLE_ERROR
}

export enum ErrorSeverity
{
    ERROR,
    INFO
}

export interface GCM
{
    isGameReady: boolean;
    balancesUpdate(balances: IGCMBalances, balanceFudge?: number, changedFromCommonUI?: boolean): any;
    gameAnimationComplete(resumeCallback: () => void): void;
    gameAnimationStart(): void;
    gameReady(): void;
    handleError(
        errorCategory: string,
        errorSeverity: string,
        errorCode: string,
        errorMessage: string,
        errorParams?: any
    ): void;
    handleMessageTrigger(messageNodeStr: string): void;
    optionHasChanged(optionType: string, changedFrom: string, newValue: boolean): void;
    paidUpdate(paid: number): any;
    regOption(optionType: string): boolean | string;
    stakeUpdate(stake: number): any;
}

export interface IGCMDelegate
{
    balancesHasChanged(balances: IGCMBalances): void;
    gameRevealed(): void;
    optionHasChanged(optionType: string, newValue: boolean): void;
    resume(errorParamIndex: number): void;
}

export interface IGCMDelegateContainer
{
    delegates: IGCMDelegate[];
    gcm: GCM;
}

export interface IGCMBalance
{
    amount: number;
}

export interface IGCMBalances
{
    CASH: IGCMBalance;
    BONUS: IGCMBalance;
}

export interface ISGDBalanceDetails
{
    wager: {
        realMc: number;
        bonusMc: number;
        totalBalance: number;
    };
    balance: {
        realMc: number;
        bonusMc: number;
        totalBalance: number;
    };
}

export interface ISGDError
{
    code: string | number;
    msg: string;
}

export interface ISGDLaunchDetails
{
    envid: string;
    dev: number;
    gameId: string;
    ogsgameid: string;
    platformOperatorId: string;
    sessionid: string;
    currency: string;
    lang: string;
    mode: string;
    accountid: string;
    device: string;
    lobbyurl: string;
}

export interface INyxWindow
{
    clientConfig:
    {
        clientconfig: INyxClientConfig;
    };
    _gcmDelegate: IGCMDelegateContainer;
}

export interface INyxClientConfig
{
    sgdErrors?: any;
    everiErrors?: any;
}
